import dayjs from 'dayjs';

export const toMoment = (value) => {
  if (!value) return dayjs();
  if (typeof value.toDate === 'function') return dayjs(value.toDate()); // Firestore Timestamp
  if (value instanceof Date) return dayjs(value); // JS Date
  if (dayjs.isDayjs(value)) return value; // already dayjs
  if (value._seconds || value.seconds) return dayjs((value._seconds || value.seconds) * 1000); // raw timestamp
  return dayjs(value); // fallback
};

/**
 * Come `toMoment`, ma restituisce `null` invece di indovinare: nessun valore →
 * `null` (non "adesso"), valore illeggibile → `null` (non un dayjs invalido).
 *
 * Serve dove la data viene **scritta** e non solo mostrata. Due trappole che
 * questa funzione chiude:
 *
 * 1. `toMoment(undefined)` vale adesso, comodo per formattare ma sbagliato per
 *    persistere: scriverebbe oggi come scadenza di qualcosa che non ce l'ha.
 * 2. col plugin `objectSupport` (attivo, vedi `lib/dayjs.js`) `dayjs({})` è
 *    **valido** e vale adesso: un oggetto sporco diventerebbe "oggi" in
 *    silenzio. Qui gli oggetti passano solo nelle forme riconoscibili
 *    (`Date`, dayjs, Timestamp Firestore).
 */
export const toMomentStrict = (value) => {
  if (value === null || value === undefined || value === '') return null;

  if (typeof value.toDate === 'function') return valid(dayjs(value.toDate()));
  if (value instanceof Date) return valid(dayjs(value));
  if (dayjs.isDayjs(value)) return valid(value);

  const seconds = value._seconds ?? value.seconds;
  if (typeof seconds === 'number') return valid(dayjs(seconds * 1000));

  // Oltre queste forme accettiamo solo stringhe e numeri (vedi punto 2).
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  return valid(dayjs(value));
};

const valid = (d) => (d?.isValid() ? d : null);

/** La stessa lettura, come `Date` — per chi persiste un valore. */
export const toDateStrict = (value) => toMomentStrict(value)?.toDate() || null;
